export default function getShortProfileForMeta(context) {
    return {
        _id: context?.session?.profile?._id ?? context?.session?.profile?.userId,
        displayName: context?.session?.profile?.displayName
    };
}
